import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideEffects } from '@ngrx/effects';
import { provideStore, Selector, StoreModule } from '@ngrx/store';

import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { appRoutes } from './app.routes';
import { NotificationService } from './core/notification/notification.service';
import { provideMsal } from './core/security/msal.config';
import { dropdownReducer } from './state/dropdown.reducer';


export const getAppState: Selector<any, any> = (state) => state;

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
export const appConfig: ApplicationConfig = {
  providers: [
    NotificationService,
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideMsal(),
    provideStore(),
    provideStoreDevtools(),
    provideEffects(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      StoreModule.forRoot({ dropdown: dropdownReducer })
    ),
  ],
};
